import {useState, useRef, useEffect, useMemo} from 'react';

import {useParams} from 'react-router-dom';

// keeps a reference to previous prop values
// analogous to looking at `prevProps` in `componentDidUpdate`
export function usePrevious<T>(value: T) {
  const ref = useRef<T>();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}

// mimic this.forceUpdate() in function components
export function useForceUpdate(isTestMode: boolean) {
  const [value, set] = useState(true);
  if (isTestMode) {
    return () => undefined;
  }
  return () => set(!value); // toggle the state to force render
}

export const useStatefulId = (seed: string) => {
  const [uniqueId] = useState(`${seed}-${Math.random()}`);
  return uniqueId;
};

export const usePolicyNumberParam = () => {
  const {policyNumber} = useParams<{policyNumber: string | undefined}>();

  return useMemo(() => policyNumber, [policyNumber]);
};

export const useFileNumberParam = () => {
  const {fileNumber} = useParams<{fileNumber: string | undefined}>();

  return useMemo(() => fileNumber, [fileNumber]);
};
